import * as Sentry from '@sentry/react';
import { version } from "../../package.json";

export const initSentry = () => {
  Sentry.init({
    dsn: "https://84c9423c71bb0104c231badb131d5d7a@o4509810351013888.ingest.us.sentry.io/4509905658511360",
    tracesSampleRate: 1.0,
    environment: import.meta.env.VITE_APP_ENVIRONMENT,
    release: version,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    sendDefaultPii: true,
    enableLogs: true,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0 
  });
}